export default __webpack_public_path__ + "static/media/image1.245566e2.png";